
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_32117","data-name":"Group 32117","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_9335","data-name":"Rectangle 9335","width":"18","height":"18","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_32104","data-name":"Group 32104","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_21106","data-name":"Path 21106","d":"M14.245 10.824h-.064V9.132a.5.5 0 00-.5-.5H9.5V7.175h2.315a2.37 2.37 0 002.367-2.367V3.69a2.37 2.37 0 00-2.367-2.367H6.186A2.37 2.37 0 003.819 3.69v1.118a2.37 2.37 0 002.367 2.367H8.5v1.457H4.32a.5.5 0 00-.5.5v1.616h-.065a2.37 2.37 0 00-2.367 2.367v1.118A2.37 2.37 0 003.755 16.6h1.118a2.37 2.37 0 002.367-2.367v-1.118a2.37 2.37 0 00-2.367-2.367H4.82V9.632h8.361v1.192h-.054a2.37 2.37 0 00-2.367 2.367v1.118a2.37 2.37 0 002.367 2.367h1.118a2.37 2.37 0 002.367-2.367v-1.118a2.37 2.37 0 00-2.367-2.367M4.819 4.808V3.69a1.368 1.368 0 011.367-1.367h5.629a1.368 1.368 0 011.367 1.367v1.118a1.368 1.368 0 01-1.367 1.367H6.186a1.368 1.368 0 01-1.367-1.367m1.421 8.307v1.118A1.368 1.368 0 014.873 15.6H3.755a1.368 1.368 0 01-1.367-1.367v-1.118a1.368 1.368 0 011.367-1.367h1.118a1.368 1.368 0 011.367 1.367m9.372 1.194a1.368 1.368 0 01-1.367 1.367h-1.118a1.368 1.368 0 01-1.367-1.367v-1.118a1.368 1.368 0 011.367-1.367h1.118a1.368 1.368 0 011.367 1.367z","fill":"#5a677d"}})])])
          )
        }
      }
    